<div class="input-group disabled">
  @if (fieldAddonStart) {
    <span
      class="input-group-text"
      [ngClass]="fieldAddonStartClass"
      >
      {{ fieldAddonStart }}
    </span>
  }

  <input
    class="form-control"
    disabled
    [placeholder]="props.placeholder"
    [value]="props.value"
    [attr.data-testid]="props.testId"
    />

  @if (fieldAddonEnd) {
    <span
      class="input-group-text"
      [ngClass]="fieldAddonEndClass"
      >
      {{ fieldAddonEnd }}
    </span>
  }
</div>
